// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileFeed-cls1___432070f0b9cef7a22c5","cls2":"ProfileFeed-cls2___62326742a89ab557018 ProfileFeed-cls1___432070f0b9cef7a22c5"};